import {
  HStack,
  Pressable,
  VStack,
  Menu,
  Avatar,
  Text,
  AvatarFallbackText,
  MenuItem,
  MenuItemLabel
} from "@gluestack-ui/themed";
import { Icon } from "@repo/core/components/core/Icon";
import WayupLogo from "@repo/core/assets/images/wayup-logo-logista.svg";

import { HeaderWebMenuProps } from "./types";
import { styles } from "./styles";
import { IconNames } from "@repo/core/components/core/Icon/types";

export const HeaderWebMenu = ({
  isMobile,
  user,
  items,
  onItemPress
}: HeaderWebMenuProps) => {
  if (isMobile) {
    return null;
  }

  return (
    <HStack
      w="$100vw"
      px="$8"
      py="$2"
      alignItems="center"
      bgColor="$backgroundLight0"
      height="$16"
      hardShadow="6"
      zIndex={1000}
    >
      <HStack flex={1} gap="$2" alignItems="center">
        <WayupLogo />
        <Text color="$textLight700" fontWeight={600} size="md">
          Negócios
        </Text>
      </HStack>
      <VStack>
        <Menu
          placement="bottom right"
          borderRadius="$lg"
          trigger={({ ...triggerProps }) => {
            return (
              <Pressable {...triggerProps} variant="ghost">
                <Avatar
                  bgColor="$amber600"
                  size="sm"
                  sx={styles.avatar}
                  borderRadius="$full"
                >
                  <AvatarFallbackText sx={styles.avatar} color="white">
                    {user?.name || "User"}
                  </AvatarFallbackText>
                </Avatar>
              </Pressable>
            );
          }}
        >
          {items?.map((item) => (
            <MenuItem
              key={item.key}
              textValue={item.label}
              bgColor="white"
              borderRadius="$lg"
              $hover-bgColor="$backgroundLight50"
              onPress={() => onItemPress(item)}
            >
              <Icon
                name={item.icon as IconNames}
                size="xs"
                color={item.iconColor}
              />
              <MenuItemLabel ml={"$2"} size="sm">
                {item.label}
              </MenuItemLabel>
            </MenuItem>
          ))}
        </Menu>
      </VStack>
    </HStack>
  );
};
